<template>
  <AdminLayout :title="$t('admin_sale_log.sale_completed_title')" :current="$c.ADMIN.TAB.CONFIRM">
    <div class="section">
      <div class="container">
        <InputSearch
          style="margin-bottom: 10px;"
          type="string" v-model="sale_name" :placeholder='$t("admin_sale_log.search_hint")' @click="search_sale"></InputSearch>
        <div>
          <SiteItem v-for="item in siteList"
                    :item="item"
                    :showBtn="false"
                    :isReport="true"
                    :isAdmin="true"
                    @remove="onRemove"
          />
        </div>
        <p class="p-center" v-if="siteList.length === 0">{{$t('common.empty_hint')}}</p>
      </div>
    </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
import SiteItem from "../../../controls/SiteItem";
import TransferPopup from "../../../controls/popup/TransferPopup";
import moment from "moment";

export default {
  name: "AdminConfirm",
  components: {
    AdminLayout,
    InputSearch,
    SiteItem,
    TransferPopup,
  },
  data() {
    return {
      sale_name:null,
      siteList: [],
      showTransferPopup:false,
      currentItem: null,
    }
  },
  methods:{
    search_sale(val){
      Utils.requestGet(this.$c.API.Admin.getCompleteReqSite, {
        keyword: val
      }).then(result => {
        this.siteList = result.data.list;
      });
    },

    showSiteDetail(siteIdx) {
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          // NavigationService.navigate('SiteDetail', {
          //   site: result.data,
          // });//!!!site정보를 넘겨주어야 합니다.
          this.$router.push('SiteDetail')
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    onShowTransfer(item){
      this.currentItem = item;
      this.showTransferPopup = true;
    },
    onRemove(idx){
        this.siteList= this.siteList.filter(it => {
          return it.f_report_idx != idx;
        });
    },
  },
  mounted() {
    this.search_sale();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
::placeholder{
  color: $text!important;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminConfirm.vue